// WP post titles arrive as HTML (entities, sometimes tags). Share URLs need
// plain text, so strip tags and decode the entities WP actually emits before
// URL-encoding.
const ENTITIES = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#039;": "'",
  "&#39;": "'",
  "&apos;": "'",
  "&nbsp;": " ",
  "&hellip;": "…",
  "&ndash;": "–",
  "&mdash;": "—",
  "&lsquo;": "‘",
  "&rsquo;": "’",
  "&ldquo;": "“",
  "&rdquo;": "”",
};

export const decodeHtmlTitle = (title = "") =>
  String(title)
    .replace(/<[^>]*>/g, "")
    .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(code))
    .replace(/&[a-z]+;|&#\d+;/gi, (entity) => ENTITIES[entity.toLowerCase()] ?? entity)
    .trim();

export const getShareLinks = (url, title) => {
  const u = encodeURIComponent(url || "");
  const plainTitle = decodeHtmlTitle(title);

  return {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
    // x.com takes title and link as one encoded `text` param — there is no
    // separate `url` param on /intent/post.
    twitter: `https://x.com/intent/post?text=${encodeURIComponent(
      `${plainTitle} ${url || ""}`.trim()
    )}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${u}`,
  };
};
